import React, { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import axios from "axios";

const Headlines = () => {
    const [headlinesData, setHeadlinesData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [formData, setFormData] = useState({
        title: "",
        status: "1",  // Assuming 1 is the default active status
    });
    const [editData, setEditData] = useState(null);

    const fetchData = async () => {
        try {
            const response = await axios.get("https://api.biznetusa.com/api/all-headlines");
            if (response.data.status === 200) {
                setHeadlinesData(response.data.headlines);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleShowModal = (data = null) => {
        if (data) {
            setEditData(data);
            setFormData({
                title: data.title,
                status: data.status,
            });
        } else {
            setEditData(null);
            setFormData({
                title: "",
                status: "1",
            });
        }
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setFormData({
            title: "",
            status: "1",
        });
        setShowModal(false);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            let response;
            if (editData) {
                response = await updateHeadline(editData.id);
            } else {
                response = await createHeadline();
            }

            if (response.data.status === 200) {
                const newEntry = response.data.newEntry;

                setHeadlinesData((prevData) => {
                    if (editData) {
                        return prevData.map((headline) =>
                            headline.id === editData.id ? { ...headline, ...newEntry } : headline
                        );
                    } else {
                        return [...prevData, newEntry];
                    }
                });

                setAlertMessage(editData ? "Headline updated successfully!" : "New headline added successfully!");
                handleCloseModal();
            } else {
                setAlertMessage("Failed to submit headline. Please try again.");
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            setAlertMessage("An error occurred while submitting the form.");
        }
    };

    const createFormData = () => {
        const data = new FormData();
        data.append("title", formData.title);
        data.append("status", formData.status);
        return data;
    };

    const updateFormData = () => {
        const data = new FormData();
        data.append("title", formData.title);
        data.append("status", formData.status);
        return data;
    };

    const createHeadline = async () => {
        const data = createFormData();
        return axios.post("https://api.biznetusa.com/api/store-headlines", data);
    };

    const updateHeadline = async (id) => {
        const data = updateFormData();
        return axios.put(`https://api.biznetusa.com/api/update-headlines/${id}`, data);
    };

    const handleDelete = async (headlineId) => {
        try {
            const response = await axios.delete(`https://api.biznetusa.com/api/deleteheadlines/${headlineId}`);
            if (response.data.status === 200) {
                fetchData();
                setAlertMessage(response.data.message);
            } else {
                setAlertMessage("Failed to delete headline.");
            }
        } catch (err) {
            console.error("Error deleting headline:", err);
            setAlertMessage("An error occurred while deleting the headline.");
        }
    };

    return (
        <div className="container mt-4">
            <h1 className="mb-3">Headlines</h1>
            {alertMessage && <Alert variant="danger">{alertMessage}</Alert>}
            <button className="btn btn-primary mb-3" onClick={() => handleShowModal()}>
                Add New Headline
            </button>

            <table className="table table-bordered table-striped text-center align-middle">
                <thead className="table-light">
                    <tr>
                        <th>ID</th>
                        <th>Title</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {headlinesData.map((mapItem) => (
                        <tr key={mapItem.id}>
                            <td>{mapItem.id}</td>
                            <td>{mapItem.title}</td>
                            <td>{mapItem.status === "1" ? "Active" : "Inactive"}</td>
                            <td>
                                <button className="btn btn-warning btn-sm me-2" onClick={() => handleShowModal(mapItem)}>
                                    Edit
                                </button>
                                <button className="btn btn-danger btn-sm" onClick={() => handleDelete(mapItem.id)}>
                                    Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {showModal && (
                <div className="modal fade show" style={{ display: "block" }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{editData ? "Edit Headline" : "Add New Headline"}</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={handleCloseModal}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={handleSubmit}>
                                    {/* Title Input */}
                                    <div className="mb-3">
                                        <label className="form-label">Title</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="title"
                                            value={formData.title}
                                            onChange={handleInputChange}
                                            placeholder="Enter title"
                                            required
                                        />
                                    </div>

                                    {/* Status Input */}
                                    <div className="mb-3">
                                        <label className="form-label">Status</label>
                                        <select
                                            className="form-control"
                                            name="status"
                                            value={formData.status}
                                            onChange={handleInputChange}
                                            required
                                        >
                                            <option value="1">Active</option>
                                            <option value="0">Inactive</option>
                                        </select>
                                    </div>

                                    <button type="submit" className="btn btn-primary">
                                        {editData ? "Update Headline" : "Add Headline"}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showModal && <div className="modal-backdrop fade show"></div>}
        </div>
    );
};

export default Headlines;
